export default "__VITE_ASSET__a48effb7__"